import React from 'react';
import { motion } from 'framer-motion';
import { LEVEL_GROUPS, WINE_LEVELS } from '../../data/wine';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

// Bokstaven växer stegvis genom skalan så progressionen syns direkt.
const LETTER_SIZES = ['text-3xl md:text-4xl', 'text-3xl md:text-[2.6rem]', 'text-4xl md:text-[2.9rem]', 'text-4xl md:text-[3.2rem]', 'text-[2.6rem] md:text-[3.5rem]', 'text-[2.8rem] md:text-[3.8rem]', 'text-[3rem] md:text-[4.1rem]', 'text-[3.2rem] md:text-[4.4rem]', 'text-[3.4rem] md:text-[4.7rem]', 'text-[3.6rem] md:text-[5rem]', 'text-[3.8rem] md:text-[5.4rem]', 'text-[4rem] md:text-[5.8rem]'];
export function WineScale() {
  return <section id="skalan" className="w-full px-6 py-24 md:py-32 border-t border-ink/10" aria-labelledby="skalan-rubrik" data-id="element-285" data-mp="1en0bu91ix37e">
      <div className="max-w-6xl mx-auto" data-id="element-286" data-mp="1ioc30j01pwhp">
        <div className="max-w-2xl" data-id="element-287" data-mp="2p3vfdxrn6v99">
          <p className="font-sans text-[10px] md:text-xs tracking-[0.3em] uppercase text-ink/45" data-id="element-288" data-mp="2p2u17kfbxsnb">
            Lite Vin-skalan
          </p>
          <h2 id="skalan-rubrik" className="mt-5 font-sans text-4xl sm:text-5xl md:text-6xl font-medium tracking-[-0.03em] uppercase leading-[0.92] text-ink" data-id="element-289" data-mp="2k37mt7nrm6cx">
            Från Fair till
            <br data-id="element-290" data-mp="2650vybh8h6mr" />
            Almost Impossible
          </h2>
          <p className="mt-6 font-sans text-sm md:text-base leading-relaxed text-ink/60" data-id="element-291" data-mp="267dd4mf63cyr">
            Tolv steg som visar vad du kan vänta dig — inte hur bra vinet
            &rdquo;är&rdquo;. Längst ner är det friskt och okomplicerat. Längst
            upp är det sådant vi bara får in några flaskor av.
          </p>
        </div>

        <div className="mt-16 space-y-14 md:space-y-20" data-id="element-292" data-mp="3ridhk3v7rxb0">
          {LEVEL_GROUPS.map(group => {
          const levels = WINE_LEVELS.filter(level => level.group === group.id);
          const isRare = group.id === 'sjukt';
          return <div key={group.id} data-id="element-293" data-mp="2gfqvjkuidz9">
                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2 pb-5 border-b border-ink/20" data-id="element-294" data-mp="2fmp6x0quenz">
                  <h3 className="font-sans text-xl md:text-2xl font-medium tracking-[-0.01em] uppercase text-ink" data-id="element-295" data-mp="7gk5t563v0nd">
                    {group.title}
                  </h3>
                  <span className="font-sans text-[11px] tracking-[0.2em] uppercase text-ink/45" data-id="element-296" data-mp="3awrbfh82z7ys">
                    Nivå {group.range}
                  </span>
                  {group.note && <span className="px-2.5 py-1 border border-ink/25 font-sans text-[9px] tracking-[0.2em] uppercase text-ink/60" data-id="element-297" data-mp="3ktvpetrrvx4i">
                      {group.note}
                    </span>}
                </div>

                <motion.ul initial="hidden" whileInView="visible" viewport={{
              once: true,
              margin: '-60px'
            }} variants={{
              visible: {
                transition: {
                  staggerChildren: 0.05
                }
              }
            }} className={`divide-y ${isRare ? 'divide-ink/20' : 'divide-ink/10'}`} data-id="element-298" data-mp="2s4yfpf1mn8nd">
                  {levels.map(level => {
                const index = WINE_LEVELS.findIndex(item => item.letter === level.letter);
                return <motion.li key={level.letter} variants={fadeUp} className={`grid grid-cols-[auto_1fr] sm:grid-cols-[10rem_1fr] gap-x-6 gap-y-1 items-baseline py-6 ${isRare ? 'bg-ink/[0.03] px-4 -mx-4' : ''}`} data-id="element-299" data-mp="vcf9cioft74k">
                        <span className={`font-sans font-medium tracking-[-0.04em] leading-[0.85] text-ink ${LETTER_SIZES[index]}`} data-id="element-300" data-mp="ckmesjtpzduq">
                          {level.letter}
                        </span>
                        <div data-id="element-301" data-mp="27pvh5s45q5kg">
                          <p className="font-serif text-xl md:text-2xl font-light text-ink" data-id="element-302" data-mp="2cn5fxydfrtky">
                            {level.name}
                          </p>
                          <p className="mt-1.5 font-sans text-sm leading-relaxed text-ink/55" data-id="element-303" data-mp="1xvn0c1oho124">
                            {level.signal}
                          </p>
                        </div>
                      </motion.li>;
              })}
                </motion.ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}